'use strict';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import memoize from 'lodash/memoize';
import moment from 'moment';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ListItem} from '../../../components/lists/ListItem';

const cachedFmt = memoize(fmt);

export function UserChannelItemView(props) {
  const latestReceived = cachedFmt(props.latestReceived);

  return (
    <ListItem
      className={classNames("UserChannelItem", props.className)}
      onClick={props.onClick}
      onContextMenu={props.onContextMenu}
    >
      <div className="UserChannelItemLeft">
        <div className="UserChannelItemLeft__wrapper">
          {props.children}
        </div>
      </div>
      <div className="UserChannelItemCenter">
        <div className="UserChannelItemCenter__content">
          <div className="UserChannelItemCenter__label-wrapper">
            <div className="UserChannelItemCenter__title-wrapper">
              <span className={classNames("UserChannelItemCenter__title", props.tagName)}>
                {`${props.tagName}:`}
              </span>
              &nbsp;{props.name}
            </div>
            <div className="UserChannelItemCenter__time">
              {latestReceived}
            </div>
          </div>
          {props.parentName ? (
            <div className="UserChannelItemCenter__parent">
              <i className="icon ion-ios-arrow-back" />
              <span>
                {props.parentName}
              </span>
            </div>
          ) : null}
          <div>
            <div
              className={classNames("UserChannelItemCenter__comment", {
                UserChannelItemCenter__comment_unread: props.hasUnread,
              })}
            >
              <div className="UserChannelItemCenter__message">
                {props.latestMessage}
              </div>
              <div className="UserChannelItemCenter__time-mobile">
                {latestReceived}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ListItem>
  );
}

UserChannelItemView.propTypes = {
  className: T.string,

  latestReceived: T.any, /* Must be Date or number */
  tagName: T.string,
  name: T.string,
  latestMessage: T.string,
  parentName: T.string,
  hasUnread: T.bool,

  onClick: T.func,
  onContextMenu: T.func,
};

UserChannelItemView.commentIndicatorClassName = 'chat-icon-container';

function fmt(date) {
  return isDate(date) || isNumber(date)
    ? moment(date).format('MMM D [at] H:mm')
    : '-';
}



// WEBPACK FOOTER //
// ./src/js/comments/components/UserChannelItem/UserChannelItemView.js